export default __webpack_public_path__ + "resources/icons/d130-2aa4.png";